import {
  Input,
  Button,
  FormItem,
  Form,
  Select,
  Switch,
  MessageBox,
  Message,
  Carousel,
  CarouselItem,
  Pagination,
  Table,
  TableColumn,
  Radio,
  Upload,
  Option,
  Steps,
  Step,
  divider,
  Card,
  Menu,
  MenuItem,
  Row,
  Col,
  Submenu,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Icon,
  Image,
  Dialog,
  Popconfirm,
  DatePicker,
} from "element-ui";
const element = {
  install: function (Vue) {
    Vue.use(Button);
    Vue.use(Switch);
    Vue.use(Select);
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(Input);
    Vue.use(Carousel);
    Vue.use(CarouselItem);
    Vue.use(Pagination);
    Vue.use(Table);
    Vue.use(TableColumn);
    Vue.use(Upload);
    Vue.use(Radio);
    Vue.use(Option);
    Vue.use(Steps);
    Vue.use(Step);
    Vue.use(divider);
    Vue.use(Card);
    Vue.use(Menu);
    Vue.use(MenuItem);
    Vue.use(Row);
    Vue.use(Col);
    Vue.use(Submenu);
    Vue.use(Dropdown);
    Vue.use(DropdownMenu);
    Vue.use(DropdownItem);
    Vue.use(Icon);
    Vue.use(Image);
    Vue.use(Dialog);
    Vue.use(Popconfirm);
    Vue.use(DatePicker);
    Vue.prototype.$msgbox = MessageBox;
    Vue.prototype.$alert = MessageBox.alert;
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$prompt = MessageBox.prompt;
    Vue.prototype.$message = Message;
  },
};
export default element;
